<div [formGroup]="parts">

  <div *ngIf="isTextArea; else normal" >
      <textarea formControlName="textValue"   cols="40" rows="5" (change)="changeData()" ></textarea>
  </div>
<ng-template #normal>
  <input matInput formControlName="textValue"   cols="40" rows="5" (change)="changeData()" >
</ng-template>

</div>

